/*
 * @Date: 2026-03-31 10:00:00
 * @Description: 学院/项目相关API - 同步小程序端institute功能
 */
import { request } from "@/request/request";
import { parameterChange } from "@/utils/utils";

export default {
  // 获取项目分类列表（分页）
  getItemClassifyPageList(data) {
    return request({
      url: "/item/getItemClassifyPageList?" + parameterChange(data),
      method: "get",
      data,
    });
  },
  // 获取项目列表（分页）
  getItemInfoPageList(data) {
    return request({
      url: "/item/getItemInfoPageList?" + parameterChange(data),
      method: "get",
      data,
    });
  },
  // 获取项目详情
  getItemDetail(data) {
    return request({
      url: "/item/getItemDetail?" + parameterChange(data),
      method: "get",
      data,
    });
  },
  // 获取项目课程列表（分页）
  getItemCoursePageList(data) {
    return request({
      url: "/item/getItemCoursePageList?" + parameterChange(data),
      method: "get",
      data,
    });
  },
};
